/**
* @ngdoc directive
* @name Error Icon. Info Icon
*
* @description
* error and info icons shortcuts
*
* @example
  <error-icon></error-icon>
  <info-icon></info-icon>
*/

app
.directive('errorIcon', function(){
    return {
        restrict: 'E',
        template: "<span class='glyphicon glyphicon-exclamation-sign' aria-hidden='true'></span><span class='sr-only'>Error:</span> "
    }
})
.directive('infoIcon', function() {
    return {
        restrict: 'E',
        template: "<span class='glyphicon glyphicon-exclamation-sign' aria-hidden='true'></span><span class='sr-only'>Details:</span> "
    }
});



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/alerticons.js